import VueCookie from 'vue-cookie';
import { getQueryVariable } from '@/helpers/utils';

export default {
	namespaced: true,
	state: {
		// partnerKey: null,
	},
	actions: {
		// eslint-disable-next-line no-empty-pattern
		storePartnerKeyCookie({}) {
			const paths = window.location.pathname.substring(1).split('/');
			let partnerKey = getQueryVariable('partnerkey') || getQueryVariable('partner_key');
			if (!partnerKey) {
				// default value for game
				switch (paths[0]) {
					case 'kartdrift':
						partnerKey = 3252;
						break;
					// case 'maplestory':
					// 	partnerKey = 3252;
					// 	break;
				}
			}
			if (partnerKey) {
				// if there is a marketing campaign key in cookie previously and new key is not a marketing key, don't overwrite
				// because marketing key has more high priority than others
				if (/MK.{3}SVG.+/.test(VueCookie.get('PARTNERKEY')) && !/MK.{3}SVG.+/.test(partnerKey)) {
					return;
				}
				VueCookie.set('PARTNERKEY', partnerKey, { expires: '7D', domain: '.nexon.com' });
			}
		},
	},

	mutations: {},
};
